import {
  CalendarDays,
  CheckSquare,
  ClipboardList,
  FileSpreadsheet,
  FolderClosed,
  LayoutDashboard,
  ListChecks,
  UserCircle,
  Settings,
  Users,
  Workflow,
} from "lucide-react";

import type { AppPermission } from "@recobra/core";
import { m } from "@recobra/i18n/messages";

export type NavItem = {
  title: () => string;
  to: string;
  icon: typeof LayoutDashboard;
  /** Omit for items visible to every authenticated caller. */
  permission?: AppPermission;
};

export const navItems: NavItem[] = [
  {
    title: m.nav_dashboard,
    to: "/",
    icon: LayoutDashboard,
    permission: ["read", "Dashboard"],
  },
  {
    title: m.nav_my_tasks,
    to: "/my-tasks",
    icon: ListChecks,
    permission: ["read", "Task"],
  },
  {
    title: m.nav_calendar,
    to: "/calendar",
    icon: CalendarDays,
    permission: ["read", "Calendar"],
  },
  {
    title: m.nav_cases,
    to: "/cases",
    icon: FolderClosed,
    permission: ["read", "Case"],
  },
  {
    title: m.nav_tasks,
    to: "/tasks",
    icon: CheckSquare,
    permission: ["readAll", "Task"],
  },
  {
    title: m.nav_clients,
    to: "/clients",
    icon: Users,
    permission: ["manage", "Client"],
  },
];

export const reportNavItems: NavItem[] = [
  {
    title: m.nav_reports_cases_by_client,
    to: "/reports/cases-by-client",
    icon: FileSpreadsheet,
    permission: ["read", "Report"],
  },
];

export const settingsNavItems: NavItem[] = [
  {
    title: m.task_settings_nav,
    to: "/settings/tasks",
    icon: Settings,
    permission: ["read", "TaskSettings"],
  },
  {
    title: m.nav_automations,
    to: "/automations",
    icon: Workflow,
    permission: ["read", "Automation"],
  },
  {
    title: m.nav_users,
    to: "/users",
    icon: UserCircle,
    permission: ["manage", "User"],
  },
  {
    title: m.nav_audit_logs,
    to: "/audit-logs",
    icon: ClipboardList,
    permission: ["read", "AuditLog"],
  },
];
